// Feedback-system keyframes — DESIGN_LANGUAGE.md §9. `pulse` is the Skeleton
// shimmer (the only looping animation permitted in chrome); it was referenced
// by Skeleton.js but never defined anywhere, so the shimmer has been silently
// dead — an unresolvable animation name emits nothing.
export default {
  pulse: {
    '0%': { opacity: '1' },
    '50%': { opacity: '0.55' },
    '100%': { opacity: '1' }
  },

  // The side-panel keyframes `panelIn` / `panelOut` were staged here until
  // brand 3.14.798 shipped them (lane D1) — brand designSystem/animation.js.

  // ── STAGED — the mirrored side-panel entrance (Nika 2026-10-30) ──────────
  // `panelIn` slides a panel in from 4% to the RIGHT (its own edge on the
  // right). A side panel on the LEFT edge (the canvas version panels beside a
  // left navbar, workspace app.js) enters from 4% to the left, the same 0.98
  // settle: the brand's travel-direction naming (fadeInLeft travels left).
  // Canonical home is brand designSystem/animation.js; `deepDefaults` fills a
  // leaf only where brand has none, so this copy goes dead the day the
  // internal-brand pin carries it, and is deleted then. Locked by
  // __tests__/stagedPanelInRight.test.js (the contract, and brand equality).
  panelInRight: {
    from: { opacity: 0, transform: 'translate3d(-4%, 0, 0) scale(0.98)' },
    to: { opacity: 1, transform: 'none' }
  }
}
